import styled from 'styled-components';
import { IonContent } from '@ionic/react';

export const IonContentWrapper = styled(IonContent)`
  .button-display {
    background-color: var(--ion-card-background);
    color: var(--ion-color-primary-contrast);
    flex-wrap: wrap;
  
    .distance-container {
      display: flex;
      align-items: center;
      justify-content: right;
  
      .distance {
        font-size: 30px;
        border: 2px solid var(--ion-color-light-shade);
        color: var(--ion-color-light-shade);
        padding: 10px;
        border-radius: 5px;
  
        &.dark {
          border: 2px solid var(--ion-color-light-tint);
          color: var(--ion-color-light-tint);
        }
  
        .unit {
          font-size: 15px;
          display: inline-block;
        }
      }
    }
  }
`;